/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit ContributionFour.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import * as fromData from 'Data/ViewsData.js'
import ContributionErrorInfo from 'DesignSystem/ContributionErrorInfo/view.js'
import Info from 'DesignSystem/Info/view.js'
import InputSmallNoLabel from 'DesignSystem/InputSmallNoLabel/view.js'
import React from 'react'
import { css } from "emotion"

let styles = {}
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
alignItems: "center",
marginTop: 7})

export default function ContributionFour({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  onChange,
onSubmit,
isInvalid,
onFocus,
onBlur,
value,
viewPath= "/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content/BasicContributions/ContributionFour"
}) {
    
    
    
    
    let data = fromData.useData({ viewPath, path: 'company.member_group_contributions[0].contribution.four_people', 
context: 'company',
validate: 'contributionBasicFour',
})
    

  return (<React.Fragment
>
<div
 data-testid="ContributionFour.Horizontal"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content/BasicContributions/ContributionFour"
 className={`views-block ${styles.Horizontal}`}
>
<Info
 data-testid="ContributionFour.Info"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content/BasicContributions/ContributionFour"
viewPath={`${viewPath}/Info`}
 text="$"
 marginRight={8}
/>
<InputSmallNoLabel
 data-testid="ContributionFour.InputSmallNoLabel"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content/BasicContributions/ContributionFour"
viewPath={`${viewPath}/InputSmallNoLabel`}
 onChange={data.onChange}
 onSubmit={data.onSubmit}
 isInvalid={data.isInvalid}
 placeholder={0}
 onFocus={onFocus}
 onBlur={onBlur}
 value={data.value}
 type="number"
 maxWidth={55}
 width={55}
/>
{
data.isInvalid ? 
<ContributionErrorInfo
 data-testid="ContributionFour.ContributionErrorInfo"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content/BasicContributions/ContributionFour"
viewPath={`${viewPath}/ContributionErrorInfo`}
 text="max $38"
/>
 : null
}
</div>
{children}
</React.Fragment>)
}